// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"125":"44615865","346":"6a167727","352":"e245a4ba","371":"191ac66f","488":"6b472b15"}[chunkId] + ".css";
};